// CSS Property tester adapted from https://gist.github.com/jackfuchs/556448
function supports( property ) {
	var style = document.createElement( 'div' ).style;

	// Ensure CSS is supported at all
	if ( typeof style === 'undefined' ) {
		return false;
	}

	// Test for standard version of property
	if ( typeof style[ property ] === 'string' ) {
		return true;
	}

	// Test for vendor specific version of property
	var vendors = [ 'Moz', 'Webkit', 'Khtml', 'O', 'ms', 'Icab' ];
	property = property.charAt( 0 ).toUpperCase() + property.substr( 1 ); // Capitalize
	for ( const vendor of vendors ) {
		if ( typeof style[ vendor + property ] === 'string' ) {
			// Return the matched prefix
			return vendor;
		}
	}

	// Otherwise return false
	return false;
}

// CSS End Event guesser
function endEvent( property, supported ) {
	var prefixes = {
		Moz: 'moz',
		Webkit: 'webkit',
		O: 'o',
		ms: 'MS',
	};

	var event = property + 'end';

	if ( typeof supported === 'string' && typeof prefixes[ supported ] === 'string' ) {
		event = prefixes[ supported ] + property.charAt( 0 ).toUpperCase() + property.substr( 1 ) + 'End';
	}

	return event;
}

supports.animation = supports( 'animation' );
supports.transition = supports( 'transition' );

endEvent.animation = endEvent( 'animation', supports.animation );
endEvent.transition = endEvent( 'transition', supports.transition );

export default { supports, endEvent };
